import { render, staticRenderFns } from "./AudioPrompt.vue?vue&type=template&id=3c0a039e&"
import script from "./AudioPrompt.vue?vue&type=script&lang=ts&"
export * from "./AudioPrompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports